<template>
  <div>
    <!-- start: page -->
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
      novalidate
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">
                    {{ translations.details }}
                  </h2>
                  <p class="card-big-info-desc">
                    {{ translations.detailsInfo }}
                  </p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{ 'has-danger': $v.area.title.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Naziv</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        v-model="area.title"
                      />

                      <form-error :model="$v.area.title" :dirty="$v.$dirty" label="Naziv"/>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{ 'has-danger': $v.area.description.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Opis</label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea class="form-control form-control-modern" v-model="area.description"></textarea>

                      <form-error :model="$v.area.description" :dirty="$v.$dirty" label="Opis"/>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Slika</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="file"
                        class="form-control form-control-modern"
                        ref="image"
                        accept="image/*"
                        @change="handlePhotoUpload"
                      />
<!--

  <span class="form-text">
    Učitajte sliku rezolucije 200px x 60px
  </span>
-->
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" v-if="imageUrl || area.imageUrl">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Slika</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <div class="popup-gallery row">
                        <div
                          class="img-fluid"
                        >
                          <img
                            class="img-thumbnail"
                            :src="imageUrl || `${baseUrl}${area.imageUrl}`"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>

        </div>
      </div>


      <div class="action-buttons d-flex justify-content-between">
        <div>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#delete-modal"
            class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
            <i class="bx bx-trash text-4 me-2"></i> {{ translations.delete }}
          </button>
        </div>
        <div class="d-flex gap-3">
          <router-link exact :to="{ name: 'InterestsAreas' }" class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3">
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="
              submit-button
              btn btn-primary btn-px-4
              py-3
              d-flex
              align-items-center
              font-weight-semibold
              line-height-1
            "
            data-loading-text="Loading..."
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
      <modal id="delete-modal">
        <h5 slot="header"><strong>{{ translations.deleteInterestsArea }}</strong></h5>
        <div slot="body">
          <span v-html="modalText">
          </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button type="button" class="btn btn-primary px-4 mx-2" @click.prevent.stop="handleDelete" data-bs-dismiss="modal">
                {{ translations.yes }}
              </button>
              <button type="button" class="btn btn-default px-4" data-bs-dismiss="modal">
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import { translations } from '@/mixins';
import validations from './validation-schema/add';
import api from '@/services/api';
import config from '@/config';
import FormError from '../shared/form-errors/FormError.vue';
import Modal from '../shared/modal/Modal.vue';

export default {
  name: 'EditInterestsArea',
  mixins: [translations],
  validations: {
    area: {
      ...validations,
    },
  },
  data() {
    return {
      imageUrl: '',
      image: {
        fileName: '',
        file: '',
      }
    };
  },
  components: { FormError, Modal },
  computed: {
    baseUrl() {
      return config.baseUrl;
    },
    modalText() {
      return this.translations.areYouSureInterestsArea.replace('{area}', `<strong>${this.area.title}</strong>`);
    },
    isFormValid() {
      return !this.$v.$invalid;
    },
    area() {
      return this.$store.getters.getInterestsArea;
    },
  },
  mounted() {
    this.$store.dispatch('getInterestsArea', this.$route.params.id);
  },
  methods: {
    submitForm() {
      this.$v.$touch();

      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      const { area, image } = this;

      if (image.file != "") {
        area.image = image;
      }

      api.updateInterestsArea(area).then((response) => {
        this.$toast.info(response.data.info);
        this.$router.push({ name: 'InterestsAreas' });
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
      });
    },
    handlePhotoUpload() {
      const file = this.$refs.image.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (e) => {
        this.image.file = e.target.result.split(',')[1];
        this.image.fileName = file.name;
      };
    },
    handleDelete() {
      api.deleteInterestsAreas([this.area.id])
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'InterestsAreas' });
        }).catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
          this.$router.push({ name: 'InterestsAreas' });
        });
    },
  },
};
</script>